import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../ui/PageShell';
import Footer from '../Footer';

interface LegalPageLayoutProps {
  title: string;
  updated: string;
  children: React.ReactNode;
  draft?: boolean;
}

export const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, updated, children, draft = true }) => (
  <PageShell>
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-orange-400/90 mb-2">Legal</p>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold text-white tracking-tight">{title}</h1>
      <p className="mt-2 text-sm text-gray-500">Last updated {updated}</p>
      {draft && <div
        className="mt-4 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-100/90"
        role="note"
      >
        Draft for attorney review. This page describes Bilt:Spec as operated by Tangents LLC and is not a guarantee of legal compliance.
      </div>}
      <article className="mt-8 space-y-6 text-[15px] leading-relaxed text-gray-300 [&_h2]:font-display [&_h2]:text-xl [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-orange-300 hover:[&_a]:text-orange-200">
        {children}
      </article>
      <p className="mt-10 text-sm text-gray-500">
        Also see <Link to="/privacy">Privacy</Link>, <Link to="/terms">Terms</Link>,{' '}
        <Link to="/community-guidelines">Community Guidelines</Link>, and <Link to="/cookies">Cookies</Link>.
      </p>
    </div>
    <Footer />
  </PageShell>
);

export default LegalPageLayout;
